module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Silver Aluminum + Turquoise Open.96770baf.png";